import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';import exportFile from 'quasar/src/utils/export-file.js';
import { api } from 'boot/axios'
import { lookup } from 'mime-types'

// const getName = (model, ext) => new Promise(resolve => {
//   Dialog.create({
//     prompt: {
//       model,
//       suffix: `.${ext}`,
//     },
//   }).onOk(name => resolve(`${name}.${ext}`))
// })

export default {
  namespaced: true,

  state: {
    authing: false,
    loading: false,
    provider: null,
    user: {},
    quota: {},
  },

  getters: {
    percentage(state) {
      return ((state.quota.usage * 100) / state.quota.limit).toFixed(2) * 1
    },
    available(state) {
      return (state.quota.limit - state.quota.usage).toFixed(2)
    },
  },

  actions: {
    async init({ commit, dispatch }) {
      const { data: provider } = await api.get('storage/status')
      commit('SET_PROVIDER', provider)
      provider && dispatch('about')
    },

    async about({ commit, state: { provider } }) {
      commit('SET_LOADING', true)
      const { data: { user, quota } } = await api.get(`storage/${provider}/about`)
      commit('SET_USER', user)
      commit('SET_QUOTA', quota)
      commit('SET_LOADING', false)
    },

    async login({ commit, dispatch }, provider) {
      commit('SET_AUTHING', provider)
      const { data } = await api.get(`storage/${provider}/login`)
      const win = window.open(data, 'login page', 'width=500,height=700,left=700,top=170')

      const { hide } = Dialog.create({
        component: () => import('components/DialogLoader.vue'),
        provider,
        focusFn: () => win.focus(),
        persistent: true,
      }).onCancel(() => {
        win.close()
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        clearInterval(interval)
      })

      const interval = setInterval(() => {
        if (win.closed) {
          clearInterval(interval)
          hide()
          dispatch('init')
          commit('SET_AUTHING', false)
        }
      }, 1000)
    },

    async logout({ commit }, provider) {
      commit('SET_AUTHING', provider)
      await api.get(`storage/${provider}/logout`)
      commit('SET_PROVIDER', null)
      commit('SET_AUTHING', false)
    },

    /*
    [
      // GOGOLE
        {
            "type": "file",
            "path": "Entity\/16019\/21E2L9S0033987.pdf",
            "file_size": 41337,
            "visibility": "private",
            "last_modified": 1658913493,
            "mime_type": "application\/pdf",
            "extra_metadata": {
                "id": "1BR65iiymEjdwztQyE1IA-KfFHasBt7kI",
                "virtual_path": "\/1o80o9IXLQIhI9ApMOdkbdq1dF08PIXNa\/1Ozux9JpBmcfETgXj61JL41zB7cw6tjl7\/1BR65iiymEjdwztQyE1IA-KfFHasBt7kI",
                "display_path": "Entity\/16019\/21E2L9S0033987.pdf",
                "filename": "21E2L9S0033987",
                "extension": "pdf"
            }
        },

      // DROPBOX
      {
            "type": "file",
            "path": "Entity\/16018\/21E2L9S0033987.pdf",
            "file_size": 41337,
            "visibility": null,
            "last_modified": 1658913550,
            "mime_type": "application\/pdf",
            "extra_metadata": []
        }
    ]
    */

    async list(_, { type, id }) {
      const { data } = await api.get(`attachments/${type}/${id}`)
      return data.map(({ type: _, extra_metadata: __, visibility: ___, ...f }) => ({
        ...f,
        size: f.file_size,
        mimetype: f.mime_type,
        filename: f.path.slice(f.path.lastIndexOf('/') + 1),
        extension: f.path.slice(f.path.lastIndexOf('.') + 1),
      }))
    },

    async download(_, { path, filename, id, type, mimetype = null }) {
      const { data } = await api.post(`attachments/${type}/${id}/download`, { path, filename }, { responseType: 'blob' })
      const status = exportFile(filename, data, mimetype || lookup(path))
      !status && Notify.create({ type: 'negative', message: 'errore' })
    },

    // async copy(_, { path, filename, extension }) {
    //   const name = await getName(filename, extension)
    //   await api.post('storage/copy', { path, name })
    // },

    // async rename(_, { path, filename, extension }) {
    //   const name = await getName(filename, extension)
    //   await api.post('storage/rename', { path, name })
    // },
  },

  mutations: {
    SET_AUTHING(state, authing) {
      state.authing = authing
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_PROVIDER(state, provider) {
      state.provider = provider
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_QUOTA(state, quota) {
      state.quota = quota
    },
  },
}
